import React from 'react';
import { colorFor } from './chips';

/**
 * A horizontal row of flow-colored suggestion chips. Each chip fires onPick(prompt).
 * Used both for the seller-derived starter chips (empty state) and the agent's
 * dynamic per-turn suggestions.
 */
export default function ChipRow({ chips, onPick, disabled }) {
  if (!chips || chips.length === 0) return null;
  return (
    <div className="wafmon-chiprow">
      {chips.map((c, i) => {
        const col = colorFor(c.flow);
        return (
          <button
            key={`${c.flow}:${c.label}:${i}`}
            className="wafmon-chip"
            disabled={disabled}
            onClick={() => onPick(c.prompt || c.label)}
            style={{ borderColor: col.bd, color: col.fg, '--chip-bg': col.bg }}
            title={c.prompt || c.label}
          >
            <span className="wafmon-chip-dot" style={{ background: col.bd }} />
            {c.label}
          </button>
        );
      })}
    </div>
  );
}
